import { useLocalStorage } from "@mantine/hooks"
import React, { createContext, useContext } from "react"

type HostContextType = {
  subdomain: string
  host: string
  protocol: string
  token?: string
  firebaseNode: string
}
const HostContext = createContext<HostContextType>(null)
const Host = ({ children }) => {
  const [token] = useLocalStorage({ key: "token" })
  const [organization] = useLocalStorage({ key: "organisation" })
  const subdomain = organization
  const host = process.env.REACT_APP_API_HOST
  const protocol = "https"
  const firebaseNode = organization

  return (
    <HostContext.Provider
      value={{
        subdomain,
        host,
        protocol,
        token,
        firebaseNode,
      }}
    >
      {children}
    </HostContext.Provider>
  )
}

const useHost = () => useContext(HostContext)
export default Host
export { useHost }
